<template>
    <div class="bg-primary text-white mb-3 mx-n3 mx-sm-0 px-3 py-3 mt-n2" style="background: url('/img/bnnr/mascot-bg-brand-generic.jpg') right center / cover no-repeat;">
        <div class="row">
        <div class="col-8">
            <div class="font-weight-bolder">
            {{ $t('CreditLimit.title') }}
            </div>
            <div class="small" v-html="$t('CreditLimit.message', { amount: $n(creditLimit.limit, 'currencyNoDecimals') } )"></div>
        </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'CreditLimit',
    props: ['creditLimit']
}
</script>
